const IS_DEV = process.env.NODE_ENV === "development";
const noop = () => {};

// Using .bind() so the browser DevTools reports the actual call site line number,
// not a line inside this file.
export const log_debug = IS_DEV ? console.debug.bind(console, "[DEBUG]") : noop;
export const log_info  = IS_DEV ? console.info.bind(console,  "[INFO]")  : noop;
export const log_warn  = IS_DEV ? console.warn.bind(console,  "[WARN]")  : noop;
export const log_error = IS_DEV ? console.error.bind(console, "[ERROR]") : noop;

const logger = {
  log:   log_debug,
  debug: log_debug,
  info:  log_info,
  warn:  log_warn,
  error: log_error,
};

export default logger;
